import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ManagedCDN.css';

const AWSManagementHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>ניהול AWS Auto Scaling ו-ECS מנוהל - ניהול AWS לארגונים | Epicfinal</title>
                <meta name="title" content="ניהול AWS Auto Scaling ו-ECS מנוהל - ניהול AWS לארגונים | Epicfinal" />
                <meta name="description" content="ניהול AWS לארגונים ב-$714.90 לחודש. Auto Scaling, זמינות גבוהה (multi-AZ), ניהול קונטיינרים ECS לעד 3 שרתי EC2. ניטור 24/7 ותמיכת מומחי AWS." />
                <meta name="keywords" content="ניהול AWS, AWS Auto Scaling, Amazon ECS, ניהול EC2, AWS High Availability, פריסה ב-multi-AZ, ניהול קונטיינרים, Load Balancer, תשתית AWS, AWS מנוהל, AWS DevOps, אופטימיזציית AWS, ניהול תשתית ענן" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/aws-management" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/aws-management" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/aws-management" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/aws-management" />
                <meta property="og:title" content="ניהול AWS Auto Scaling ו-ECS מנוהל | Epicfinal" />
                <meta property="og:description" content="ניהול AWS לארגונים ב-$714.90 לחודש. Auto Scaling, זמינות גבוהה, קונטיינרים ECS לעד 3 שרתי EC2." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal AWS מנוהל - Auto Scaling ו-ECS" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/aws-management" />
                <meta name="twitter:title" content="ניהול AWS Auto Scaling ו-ECS מנוהל | Epicfinal" />
                <meta name="twitter:description" content="ניהול AWS לארגונים ב-$714.90 לחודש. Auto Scaling, זמינות גבוהה וקונטיינרים ECS." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "ניהול AWS Auto Scaling ו-ECS מנוהל",
                        "description": "ניהול AWS מקצה לקצה כולל Auto Scaling, זמינות גבוהה (multi-AZ) וניהול קונטיינרים ECS לעד 3 שרתי EC2",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "ניהול ענן AWS",
                        "areaServed": "Worldwide",
                        "offers": {"@type": "Offer", "price": "714.90", "priceCurrency": "USD", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock"},
                        "url": "https://epicfinal.com/he/aws-management"
                    }
                `}</script>
            </Helmet>

            <div className="managed-cdn-page">
                <section className="cdn-hero">
                    <div className="container">
                        <div className="cdn-hero-content">
                            <div className="cdn-icon-badge">
                                <i className="lab la-aws"></i>
                            </div>
                            <h1 className="cdn-hero-title">
                                ניהול AWS Auto Scaling ו-ECS מנוהל
                            </h1>
                            <p className="cdn-hero-subtitle">
                                ניהול AWS Auto Scaling וזמינות גבוהה
                            </p>
                            <p className="cdn-hero-description">
                                ניהול מקצה לקצה של סביבת AWS שנבנתה לחוסן ולזמינות – כולל הגדרה ותפעול שוטף של Auto Scaling וזמינות גבוהה (multi-AZ במידת הצורך), כדי לשמור על עומסי העבודה שלכם מהירים ויציבים גם תחת תעבורה משתנה.
                            </p>
                            <div className="cdn-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-aws-auto-scaling-and-ecs-up-to-3-servers&language=hebrew&currency=2"
                                    className="btn-cdn btn-primary" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו - ₪2490.00 לחודש
                                </a>
                                <Link to="/contact1" className="btn-cdn btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-features">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>ניהול AWS לארגונים</h2>
                            <p>תשתית ענן גמישה ועמידה</p>
                        </div>
                        <div className="cdn-features-grid">
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-expand-arrows-alt"></i>
                                </div>
                                <h3>Auto Scaling</h3>
                                <p>הרחבה אוטומטית המבוססת על הביקוש, לטיפול יעיל בפרצי תעבורה.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>זמינות גבוהה</h3>
                                <p>פריסה ב-Multi-AZ לזמינות מרבית ולעמידות בפני תקלות.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-server"></i>
                                </div>
                                <h3>עד 3 שרתי EC2</h3>
                                <p>ניהול של עד שלושה מופעי EC2, כולל הגדרה וניטור מלאים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-box"></i>
                                </div>
                                <h3>ניהול קונטיינרים ECS</h3>
                                <p>פריסה, עדכונים וניטור תקינות עבור קונטיינרים של Amazon ECS.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-chart-line"></i>
                                </div>
                                <h3>ניטור ביצועים</h3>
                                <p>ניטור רציף של משאבים, אפליקציות ותקינות הקונטיינרים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-sync"></i>
                                </div>
                                <h3>תחזוקה שוטפת</h3>
                                <p>עדכונים שוטפים, טלאי אבטחה ואופטימיזציה לתשתית ה-AWS שלכם.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-included">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>מה כלול בשירות</h2>
                            <p>ניהול מלא לתשתית ה-AWS שלכם</p>
                        </div>
                        <div className="cdn-included-grid">
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> Auto Scaling ו-HA</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> הגדרת Auto Scaling</li>
                                    <li><i className="las la-angle-left"></i> פריסה ב-Multi-AZ</li>
                                    <li><i className="las la-angle-left"></i> הגדרת Load Balancer</li>
                                    <li><i className="las la-angle-left"></i> מדיניות הרחבה (Scaling)</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> ניהול ECS</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> פריסת קונטיינרים</li>
                                    <li><i className="las la-angle-left"></i> עדכוני אימג'ים (Images)</li>
                                    <li><i className="las la-angle-left"></i> ניטור בריאות</li>
                                    <li><i className="las la-angle-left"></i> ניהול שירותים (Orchestration)</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> ניטור ותמיכה</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> ניטור תשתית רציף</li>
                                    <li><i className="las la-angle-left"></i> אופטימיזציית ביצועים</li>
                                    <li><i className="las la-angle-left"></i> פתרון תקלות</li>
                                    <li><i className="las la-angle-left"></i> תמיכת מומחי AWS</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="cdn-pricing">
                    <div className="container">
                        <div className="cdn-pricing-card">
                            <div className="cdn-pricing-header">
                                <h2>שירות ניהול AWS</h2>
                                <p>תשתית AWS ברמה ארגונית</p>
                            </div>
                            <div className="cdn-pricing-body">
                                <div className="cdn-pricing-amount">
                                    <span className="cdn-price">$714.90</span>
                                    <span className="cdn-period">חודשי / USD</span>
                                </div>
                                <ul className="cdn-pricing-features">
                                    <li><i className="las la-check"></i> עד 3 שרתי EC2</li>
                                    <li><i className="las la-check"></i> הגדרת Auto Scaling</li>
                                    <li><i className="las la-check"></i> זמינות גבוהה (Multi-AZ)</li>
                                    <li><i className="las la-check"></i> ניהול קונטיינרים ECS</li>
                                    <li><i className="las la-check"></i> הגדרת Load Balancer</li>
                                    <li><i className="las la-check"></i> ניטור רציף</li>
                                    <li><i className="las la-check"></i> אופטימיזציית ביצועים</li>
                                    <li><i className="las la-check"></i> תמיכת מומחי AWS</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-aws-auto-scaling-and-ecs-up-to-3-servers&language=hebrew&currency=2"
                                    className="cdn-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cdn-cta">
                    <div className="container">
                        <div className="cdn-cta-content">
                            <h2>מוכנים להרחיב את תשתית ה-AWS שלכם?</h2>
                            <p>תנו למומחי ה-AWS שלנו לבנות ולנהל את סביבת הענן העמידה שלכם.</p>
                            <div className="cdn-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-aws-auto-scaling-and-ecs-up-to-3-servers&language=hebrew&currency=2"
                                    className="btn-cdn btn-light" target="_blank" rel="noopener noreferrer">
                                    הזמינו שירות
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-cdn btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AWSManagementHe;
